import React, { useRef, useState } from 'react'
import classNames from 'classnames'

import Checkbox from '_components/checkbox'
import { useDialog } from '_hooks'
import IconFilter from '_icons/IconFilter'

const DestinationsFilter = ({
  audience,
  setAudience,
  destinations,
  disabled,
  name = 'Add Destinations',
}) => {
  const [query, setQuery] = useState('')

  const handleSearch = (event) => {
    setQuery(event.target.value)
  }

  const baseRef = useRef(null)
  const targetRef = useRef(null)

  const { dialog, Dialog } = useDialog({
    wrapperNode: baseRef.current,
    targetNode: targetRef.current,
    maxSize: {
      width: 450,
      height: 230,
    },
  })

  const isChecked = (value) => audience.destinations?.find((d) => d.name === value.name)

  const handleChange = (value) => () => {
    if (disabled) return
    if (isChecked(value)) {
      setAudience((audience) => ({
        ...audience,
        destinations: audience.destinations.filter((destination) => destination._id !== value._id),
      }))
    } else {
      setAudience((audience) => ({
        ...audience,
        destinations: [value, ...audience.destinations],
      }))
    }
  }

  return (
    <div className={classNames('filters', { 'filters--disabled': disabled })} ref={baseRef}>
      <button className="filters__initial" ref={targetRef} onClick={dialog.show}>
        <IconFilter fill="#fff" />
        <span>{name}</span>
      </button>
      <Dialog>
        <div className={classNames('filters-control')}>
          <div className="filters-control__values mac-scrollbar">
            <input
              type="search"
              name=""
              id=""
              placeholder="Search"
              value={query}
              onChange={handleSearch}
            />
            {destinations
              ?.filter((value) => !query || value.name.toLowerCase().includes(query.toLowerCase()))
              ?.map((value) => (
                <Checkbox
                  key={value.name}
                  name={value.name}
                  label={value.name}
                  checked={isChecked(value)}
                  onChange={handleChange(value)}
                />
              ))}
          </div>
        </div>
      </Dialog>
    </div>
  )
}

export default DestinationsFilter
